import { getTaskLocation } from './taskLocation';
export default ({
  projectSites,
  projectUrls,
  windowLocation
}: {
  projectSites?: any[];
  projectUrls?: string[];
  windowLocation: Location;
}): { pathname: string; hostname: string } => {
  const location = { hostname: '', pathname: '' };
  const windowHref = windowLocation?.href;
  if (projectSites && projectSites.length > 0) {
    const taskLocation = getTaskLocation({
      browserLocation: windowHref,
      projectSites: projectSites
    });
    location.hostname = taskLocation && taskLocation.projectSite;
    location.pathname = taskLocation && taskLocation.pageLocation;
  } else {
    const hostUrl = projectUrls?.find(projectUrl => {
      const url = projectUrl.replace('*', '');
      const escUrl = url.replace(
        /\[|\^|\$|\.|\||\?|\*|\+|\(|\)/gi,
        x => '\\' + x
      );
      return RegExp(escUrl).test(windowHref);
    });
    if (!!hostUrl) {
      location.hostname = hostUrl.endsWith('/')
        ? hostUrl.substring(0, hostUrl.length - 1)
        : hostUrl;
      var pathname =
        hostUrl === windowHref ||
        hostUrl + '/' === windowHref ||
        hostUrl === windowHref + '/'
          ? '/'
          : windowHref.slice(hostUrl.length);
      location.pathname = pathname.startsWith('/') ? pathname : '/' + pathname;
    } else {
      // javascript embedded and project url differs from browser url
      location.hostname = windowLocation.protocol + '//' + windowLocation.host;
      location.pathname =
        windowLocation.pathname + windowLocation.search + windowLocation.hash;
    }
  }
  return location;
};
